module.exports = __webpack_public_path__ + "static/img/AIRWALLEX.c755868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sureOrder/AIRWALLEX.svg
// module id = qHjV
// module chunks = 0